import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class HttpJsonInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.body) {
      const contentType = request.headers.get('Content-Type');
      if (!contentType && typeof request.body === 'object') {
        request = request.clone({
          headers: request.headers.append('Content-Type', 'application/json'),
          body: JSON.stringify(request.body),
        });
      }
    }

    if (!request.headers.get('bis-api-security')) {
      request = request.clone({
        headers: request.headers.append('bis-api-security', 'null'),
      });
    }

    return next.handle(request);
  }
}
